<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ $t('USERS.USER_MANAGEMENT') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="dialogCreate = true">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('USERS.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <users @edit="editedUser"></users>
    </v-sheet>

    <v-dialog
      v-if="dialogCreate"
      v-model="dialogCreate"
      persistent
      max-width="800px"
    >
      <create
        @cancel="dialogCreate = !dialogCreate"
        @created="createdUser"
      ></create>
    </v-dialog>

    <v-dialog
      v-if="dialogEdit"
      v-model="dialogEdit"
      persistent
      max-width="800px"
    >
      <edit
        :id="user.id"
        @cancel="dialogEdit = !dialogEdit"
        @updated="editedUser"
      ></edit>
    </v-dialog>
  </div>
</template>

<script>
import Users from '@/modules/users/components/Users';
import Create from '@/modules/users/components/CreateUser';
import Edit from '@/modules/users/components/EditUser';

export default {
  name: 'UsersLayout',

  components: {
    Users,
    Create,
    Edit
  },

  data: () => ({
    dialogCreate: false,
    dialogEdit: false,

    user: {}
  }),

  methods: {
    createdUser() {
      this.refresh();
      this.dialogCreate = !this.dialogCreate;
    },

    editedUser(user) {
      this.user = user;
      this.refresh();
      this.dialogEdit = !this.dialogEdit;
    },

    refresh() {
      this.$store.dispatch('user/retrieveUsers').then(({ data }) => {
        this.$store.commit('user/retrievedUsers', data);
      });
    }
  }
};
</script>
